import { Building2, ExternalLink, User } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const AboutUs = () => {
  return (
    <section id="about" className="py-20 bg-gray-50" aria-label="About Us section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-base sm:text-lg text-blue-900 font-semibold mb-2">About Us</h2>
          <h3 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Expert TOR1 Services You Can Trust
          </h3>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-none shadow-xl bg-white">
            <CardContent className="pt-8 pb-8 px-8 md:px-12">
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  <strong className="text-gray-900">TOR1 Services</strong> is a subsidiary of Sunshine Storage and Transport, backed by over <strong>15 years of international removals experience</strong>.
                </p>

                <p>
                  We specialise in <strong className="text-blue-900">Transfer of Residence (ToR1) applications</strong>, customs clearance, and cross-border relocation support.
                </p>

                <p>
                  Having assisted <strong className="text-gray-900">hundreds of customers</strong>, we combine real-world removals expertise with in-depth knowledge of UK customs processes to deliver a smooth, compliant, and stress-free service.
                </p>

                <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-900 mt-8">
                  <div className="flex items-start">
                    <User className="text-blue-900 mr-4 mt-1 flex-shrink-0" size={32} />
                    <div>
                      <p className="text-gray-900 font-semibold mb-2">
                        TOR1 Services is managed by <strong>Philip Russell</strong>, Operations and Business Manager at Sunshine Storage and Transport, offering trusted, hands-on support throughout the entire ToR1 process.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="pt-8 border-t border-gray-200 mt-8">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <Building2 className="mr-2 text-blue-900" size={24} />
                    Our Parent Company
                  </h4>
                  <p className="mb-3">Learn more about our parent company:</p>
                  <a 
                    href="https://www.sunshinestorageandtransport.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-900 hover:text-blue-700 font-semibold text-lg transition-colors group"
                  >
                    Sunshine Storage and Transport
                    <ExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                  </a>
                </div>

                <div className="pt-6 border-t border-gray-200 mt-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <User className="mr-2 text-blue-900" size={24} />
                    Connect with Philip
                  </h4>
                  <a 
                    href="https://www.linkedin.com/in/philip-russell-a974a3129/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-900 hover:text-blue-700 font-semibold text-lg transition-colors group"
                  >
                    Philip Russell - LinkedIn Profile
                    <ExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
